export class PersonModel {
    public FirstName: string;
    public LastName: string;    
    public EmailAddress: string;
    public Phone: string;
    public UserRole: string;
    public FAX: string;
    public StateName: string;
    public CityName: string;
    public Address1: string;
    public CellPhone: string;
    public Email:string;
}


// WEBPACK FOOTER //
// ./src/app/models/PersonModel.ts